import * as React              from 'react'
import { RouteComponentProps } from 'react-router'

import { AccountType }             from '../api'
import {
  BossForm,
  CredentialsForm,
  EducationFormStep,
  ExperienceFormStep,
  PersonalInformationForm,
}                                  from '../components/forms'
import CoachingCertificateFormStep from '../components/forms/CoachingCertificatesFormStep'
import CoachingExperienceFormStep  from '../components/forms/CoachingExperienceFormStep'
import CoachingStudiesFormStep     from '../components/forms/CoachingStudiesFormStep'
import { Registration }            from '../components/organisms'

const FormStep = (label, form) => {
  return {
    label,
    form,
  }
}

const formSteps = {
  credentials:          FormStep('credentials', CredentialsForm),
  education:            FormStep('education', EducationFormStep),
  personalInformation:  FormStep('personalInformation', PersonalInformationForm),
  experience:           FormStep('experience', ExperienceFormStep),
  boss:                 FormStep('boss', BossForm),
  coachingExperience:   FormStep('coachingExperience', CoachingExperienceFormStep),
  coachingStudies:      FormStep('coachingStudies', CoachingStudiesFormStep),
  coachingCertificates: FormStep('coachingCertificates', CoachingCertificateFormStep),
}

type RegistrationComponent = React.SFC<RouteComponentProps<{ token: string }>>

export const RegistrationMentee: RegistrationComponent = props => (
  <Registration
    accountType={AccountType.Mentee}
    steps={[
      formSteps.credentials,
      formSteps.personalInformation,
      formSteps.education,
      formSteps.experience,
    ]}
    {...props}
  />
)

export const RegistrationMentor: RegistrationComponent = props => (
  <Registration
    accountType={AccountType.Mentor}
    steps={[
      formSteps.credentials,
      formSteps.personalInformation,
      formSteps.education,
      formSteps.experience,
    ]}
    {...props}
  />
)

export const RegistrationCompanyMentoring: RegistrationComponent = props => (
  <Registration
    accountType={AccountType.CompanyMentoring}
    steps={[ formSteps.credentials ]}
    {...props}
  />
)

export const RegistrationCoachee: RegistrationComponent = props => (
  <Registration
    accountType={AccountType.Coachee}
    steps={[
      formSteps.credentials,
      formSteps.personalInformation,
      formSteps.education,
      formSteps.experience,
      formSteps.boss,
    ]}
    {...props}
  />
)

export const RegistrationCoach: RegistrationComponent = props => (
  <Registration
    accountType={AccountType.Coach}
    steps={[
      formSteps.credentials,
      formSteps.personalInformation,
      formSteps.education,
      formSteps.experience,
      formSteps.coachingExperience,
      formSteps.coachingStudies,
      formSteps.coachingCertificates,
    ]}
    {...props}
  />
)

export const RegistrationCompanyCoaching: RegistrationComponent = props => (
  <Registration
    accountType={AccountType.CompanyCoaching}
    steps={[ formSteps.credentials ]}
    {...props}
  />
)



// WEBPACK FOOTER //
// ./src/routing/Registrations.tsx